import API from './API.ts'

export default {
  //
  // GET
  //
  getProductGroupSales ({ startDate, endDate, registerId }) {
    return API.httpClient.get('statistics/product-group-sales', {
      params: {
        register_id: registerId,
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getBookingsPerChannel ({ startDate, endDate }) {
    return API.httpClient.get('statistics/bookings-per-channel', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCheckInsByUser ({ startDate, endDate }) {
    return API.httpClient.get('statistics/checkins-by-user', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCheckoutsByUser ({ startDate, endDate }) {
    return API.httpClient.get('statistics/checkouts-by-user', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCheckinsAndCheckoutsPerHour ({ startDate, endDate }) {
    return API.httpClient.get('statistics/checkins-and-checkouts-per-hour', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getScbExports () {
    return API.httpClient.get('scb/exports')
  },
  getMonthlyCheckinsAndCheckouts (month) {
    return API.httpClient.get('statistics/monthly-checkins-and-checkouts', {
      params: {
        month: month.format('YYYY-MM-DD')
      }
    })
  },
  getYearlyCheckinsAndCheckouts (year) {
    return API.httpClient.get('statistics/yearly-checkins-and-checkouts', {
      params: {
        year: year.format('YYYY')
      }
    })
  },
  getCheckedInCustomers () {
    return API.httpClient.get('statistics/checked-in-customers')
  },
  getCustomerCounts () {
    return API.httpClient.get('statistics/customer-counts')
  },
  getCustomerNationalityNights () {
    return API.httpClient.get('statistics/customer-nationality-nights')
  },
  getRevenueNumbers () {
    return API.httpClient.get('statistics/revenue-numbers')
  },
  getCategoryOccupation () {
    return API.httpClient.get('statistics/category-occupation')
  },
  getAccommodationValue () {
    return API.httpClient.get('statistics/accommodation-value')
  },
  getWeatherForecast () {
    return API.httpClient.get('weather-forecast')
  },
  getBathingWaterTemperatures ({ pinnedIds, nearbyResultsLimit }) {
    return API.httpClient.get('statistics/bathing-water-temperatures', {
      params: {
        pinned_ids: pinnedIds,
        limit: 30,
        nearby_results_limit: nearbyResultsLimit
      }
    })
  },
  getHistoricalTurnoverFullAccrual () {
    return API.httpClient.get('statistics/historical-turnover-full-accrual')
  },
  getHistoricalTurnoverPartAccrual () {
    return API.httpClient.get('statistics/historical-turnover-part-accrual')
  },
  getOccupancyStats () {
    return API.httpClient.get('statistics/occupancy-stats')
  },
  getPositionTurnover ({ startDate, endDate }) {
    return API.httpClient.get('statistics/position-turnover', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCategoryTurnover ({ startDate, endDate }) {
    return API.httpClient.get('statistics/category-turnover', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getYearlyGuestNightsSummary (year) {
    return API.httpClient.get('statistics/yearly-guest-nights-summary', {
      params: {
        year
      }
    })
  },
  getPositionOccupation ({ startDate, endDate }) {
    return API.httpClient.get('statistics/position-occupation', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCategoryOccupationInInterval ({ startDate, endDate }) {
    return API.httpClient.get('statistics/category-occupation-in-interval', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },

  //
  // POST
  //
  createScbExport (month) {
    return API.httpClient.post('scb/create', {
      month: month.format('YYYY-MM-DD')
    })
  },
  confirmScbExport (scbExportId) {
    return API.httpClient.post('scb/confirm', {
      scb_export_id: scbExportId
    })
  }
}
